import React from 'react';
import { Box, Typography } from '@mui/material';
import { DataTable, formatDateTime } from 'components/shared';

// There is no 404 / not-found logging endpoint in state/api.js, so this tab has
// no real data source. Per the design rules we render a clean empty state via
// the shared DataTable instead of fabricating template rows or exposing dead
// delete / redirection controls.
const COLUMNS = [
  { field: 'url', headerName: 'URL' },
  { field: 'hits', headerName: 'Hits', align: 'right' },
  {
    field: 'lastHit',
    headerName: 'Last Hit',
    render: (row) => formatDateTime(row.lastHit),
  },
];

const Logs = () => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        404 Logs
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Track page-not-found errors encountered by visitors on your storefront.
      </Typography>
      <DataTable
        columns={COLUMNS}
        rows={[]}
        emptyText="No 404 errors have been recorded yet."
      />
    </Box>
  );
};

export default Logs;
